export default __webpack_public_path__ + "static/media/projTrack8Full.ff37071b.png";